import { createElement } from 'react';
import * as FaIcons from 'react-icons/fa';
import * as MdIcons from 'react-icons/md';

const allIcons = { ...FaIcons, ...MdIcons };

const DynamicIcon = ({ name, className = '', size = 24 }) => {
  if (!name) return null;

  const Icon = allIcons[name];

  if (!Icon || typeof Icon !== 'function') return null;

  return createElement(Icon, { className, size });
};

export default DynamicIcon;